(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature-spotlight"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  // ── Initialise every instance of this section on the page ─────────────────
  // blocks are deduplicated by Shopify, so this code runs
  // once regardless of how many times the section appears. We therefore loop
  // over all matching elements rather than targeting a single ID.
  document.querySelectorAll('.pfs-section').forEach(function (sectionEl) {

    // ── Guard: only run once per section instance ────────────────────────────
    if (sectionEl.dataset.pfsInit === 'true') return;
    sectionEl.dataset.pfsInit = 'true';

    // ── Guard: prefers-reduced-motion ───────────────────────────────────────
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Make everything visible instantly
      sectionEl.querySelectorAll('.pfs__callout').forEach(function (el) {
        el.style.opacity = '1';
      });
      return;
    }

    // ── Guard: GSAP + ScrollTrigger must be available ────────────────────────
    // The theme loads GSAP + ScrollTrigger from CDN in layout/theme.liquid
    // before kokum-animations.js. runs after DOMContentLoaded.
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      // Graceful fallback: make everything visible
      sectionEl.querySelectorAll('.pfs__callout').forEach(function (el) {
        el.style.opacity = '1';
      });
      var img = sectionEl.querySelector('.pfs__product-img');
      if (img) img.style.opacity = '1';
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Lenis smooth-scroll sync (same pattern as kokum-animations.js)
    if (window.__lenis) {
      window.__lenis.on('scroll', function () { ScrollTrigger.update(); });
      gsap.ticker.lagSmoothing(0);
    }

    // ── Elements ─────────────────────────────────────────────────────────────
    var productImg = sectionEl.querySelector('.pfs__product-img');
    var callouts   = sectionEl.querySelectorAll('.pfs__callout');
    var lines      = sectionEl.querySelectorAll('.pfs__line line');

    // ── Set initial states (hide before animation) ───────────────────────────
    if (productImg) gsap.set(productImg, { opacity: 0, y: 80 });
    gsap.set(callouts, { opacity: 0 });
    gsap.set(lines,    { strokeDashoffset: 60 });

    // ── Build the main timeline ───────────────────────────────────────────────
    // The timeline is driven by a pinned ScrollTrigger rather than scrub, so
    // the animations play through at normal speed while the section is pinned.
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionEl,
        start: 'top top',         // pin as soon as the section hits the top edge
        end: '+=140%',            // how far the user scrolls while pinned
                                  // (100% = 1 additional viewport-height of scroll)
        pin: true,                // hold the section in place
        pinSpacing: true,         // add spacer div below so content flows after
        anticipatePin: 1,         // start measuring a little early for smoothness
        // No scrub: the timeline plays freely, linked only by the onEnter hook
        onEnter: function () { tl.play(); },
        onLeaveBack: function () { tl.pause(0); },
      },
      paused: true,               // starts paused; ScrollTrigger.onEnter plays it
    });

    // 1. Product image rises up
    if (productImg) {
      tl.to(productImg, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'power3.out',
        clearProps: 'will-change',
      });
    }

    // 2. Callouts fade in one-by-one, 0.4 s stagger, starting just before
    //    the image animation finishes (overlap = –0.1 s)
    if (callouts.length) {
      tl.to(callouts, {
        opacity: 1,
        duration: 0.5,
        stagger: 0.4,
        ease: 'power2.out',
      }, '-=0.1');
    }

    // 3. SVG lines draw in, synced with each callout's own fade-in
    if (lines.length) {
      tl.to(lines, {
        strokeDashoffset: 0,
        duration: 0.4,
        stagger: 0.4,
        ease: 'power2.inOut',
      }, '<'); // '<' starts at same position as the callout fade group above
    }

  }); // end forEach .pfs-section

})();


  } catch(e) { console.error(e); }
})();
})();
